/* unplugin-vue-components disabled */var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._b({staticClass:"text-current hover:text-primary",class:( _obj = {}, _obj[_vm.activateClass] = _vm.activate, _obj ),staticStyle:{"display":"block"},attrs:{"href":_vm.href,"target":_vm.target},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},'a',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }